import { FieldMetricsService } from './field-metrics.service';

export default angular
  .module('sfMobile.services.field-metrics', [
    'sfMobile.services.dashboards',
    'sfMobile.services.metrics',
  ])
  .factory('fieldMetricsService', FieldMetricsService).name;
